import { Language } from '../enums';

export const UNKNOWN_LANG = 'Unknown';
export class EmployeeLicenseSummaryLanguage {
  active = 0;

  applicationInProgress = 0;

  pending = 0;

  expired = 0;

  language: Language | 'Unknown';

  constructor(obj: any) {
    Object.assign(this, obj);
    this.language = Language.byKey[obj.language] || UNKNOWN_LANG;
  }

  static sort(
    a: EmployeeLicenseSummaryLanguage,
    b: EmployeeLicenseSummaryLanguage,
  ) {
    const aPreferred = Language.PREFERRED_LANGUAGES.includes(
      a.language as Language,
    );
    const bPreferred = Language.PREFERRED_LANGUAGES.includes(
      b.language as Language,
    );
    if (b.language === UNKNOWN_LANG) return -1;
    if (a.language === UNKNOWN_LANG) return 1;
    if (aPreferred && !bPreferred) return -1;
    if (!aPreferred && bPreferred) return 1;
    return a.language?.toString()?.localeCompare(b.language?.toString() || '');
  }
}

export default EmployeeLicenseSummaryLanguage;
